import { IntroScreen } from './IntroScreen';

export default IntroScreen;
